import types from "./types";

const defaultValues = {
  showFooter: false,
  expandFooter: false,
};

export default function reducer(state = defaultValues, action) {
  switch (action.type) {
    case types.SHOW_FOOTER: {
      return {
        ...state,
        showFooter: true,
        expandFooter: true,
      };
    }

    case types.HIDE_FOOTER: {
      return {
        ...state,
        showFooter: false,
      };
    }

    case types.EXPAND_FOOTER: {
      return {
        ...state,
        expandFooter: true,
      };
    }

    case types.COLLAPSE_FOOTER: {
      return {
        ...state,
        expandFooter: false,
      };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/magnetFooter/reducers.js